import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const HeadingMobileStyles = styled.div`
  .home-info-mobile {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    width: 100%;

    .see-below span {
      font-family: 'source-sans-pro', sans-serif;
      font-size: 12px;
      color: ${Colors.accent.grey1.standard};
      text-decoration: underline;
    }
  }
  .home-specs-container {
    margin: 20px 0;
  }

  @media screen and (max-width: 350px) {
    .home-specs-container {
      > div {
        flex-wrap: wrap;

        > div {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
`;
